import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=4610cd24&scoped=true&lang=pug&"
import script from "./NotificationBell.vue?vue&type=script&setup=true&lang=js&"
export * from "./NotificationBell.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&id=4610cd24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4610cd24",
  null
  
)

export default component.exports